import { isUserLoggedIn } from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'

export default [
    {
        path: '/users',
        name: 'users',
        component: () => import('@/views/users-and-roles/users/Lists.vue'),
        meta: {
            pageTitle: 'Users',
            resource: 'user',
            action: 'read',
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Users',
                    active: true,
                },
            ],
        },
        beforeEnter: async (to, from, next) => {
            // Get logged in status
            const isLoggedIn = isUserLoggedIn()
      
            // If not logged in, then redirect to login page
            if (!isLoggedIn) {
              return next('/login')
            }
            
            // If login and not have access
            if (!canNavigate(to)) {
              return next({ name: 'misc-not-authorized' })
            }
            return next()
        },
    },
    {
        path: '/user/edit/:id',
        name: 'edit-user',
        component: () => import('@/views/users-and-roles/users/Edit.vue'),
        meta: {
            pageTitle: 'Edit User',
            resource: 'user',
            action: 'edit',
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Users',
                },
                {
                    text: 'Edit',
                    active: true,
                },
            ],
        },
        beforeEnter: (to, from, next) => {
            // Get logged in status
            const isLoggedIn = isUserLoggedIn()
      
            // If not logged in, then redirect to login page
            if (!isLoggedIn) {
              return next('/login')
            }
            
            // If login and not have access
            if (!canNavigate(to)) {
              return next({ name: 'misc-not-authorized' })
            }
            return next()
        },
    },
    {
        path: '/roles',
        name: 'roles',
        component: () => import('@/views/users-and-roles/roles/Lists.vue'),
        meta: {
            pageTitle: 'Roles',
            resource: 'role',
            action: 'read',
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Roles',
                    active: true,
                },
            ],
            createUrl: 'create-role',
            showCreateButton: true,
        },
        beforeEnter: (to, from, next) => {
            // Get logged in status
            const isLoggedIn = isUserLoggedIn()
      
            // If not logged in, then redirect to login page
            if (!isLoggedIn) {
              return next('/login')
            }
            
            // If login and not have access
            if (!canNavigate(to)) {
              return next({ name: 'misc-not-authorized' })
            }
      
            return next()
        },
    },
    {
        path: '/role/create',
        name: 'create-role',
        component: () => import('@/views/users-and-roles/roles/Create.vue'),
        meta: {
            pageTitle: 'Create Role',
            resource: 'role',
            action: 'create',
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Roles',
                },
                {
                    text: 'Create',
                    active: true,
                },
            ],
        },
        beforeEnter: (to, from, next) => {
            // Get logged in status
            const isLoggedIn = isUserLoggedIn()
      
            // If not logged in, then redirect to login page
            if (!isLoggedIn) {
              return next('/login')
            }
            
            // If login and not have access
            if (!canNavigate(to)) {
              return next({ name: 'misc-not-authorized' })
            }
      
            return next()
        },
    },
    {
        path: '/role/edit/:id',
        name: 'edit-role',
        component: () => import('@/views/users-and-roles/roles/Edit.vue'),
        meta: {
            pageTitle: 'Edit Role',
            resource: 'role',
            action: 'edit',
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Roles',
                },
                {
                    text: 'Edit',
                    active: true,
                },
            ],
        },
        beforeEnter: (to, from, next) => {
            // Get logged in status
            const isLoggedIn = isUserLoggedIn()
      
            // If not logged in, then redirect to login page
            if (!isLoggedIn) {
              return next('/login')
            }
            
            // If login and not have access
            if (!canNavigate(to)) {
              return next({ name: 'misc-not-authorized' })
            }
      
            return next()
        },
    },
]